class State {
    constructor() {
        this.items = [];
        this.nextId = 1;
    }
    static getInstance() {
        if (!State.instance) {
            State.instance = new State();
        }
        return State.instance;
    }
    addItem(item) {
        this.items.push(Object.assign(Object.assign({}, item), { id: this.nextId++ }));
    }
    removeItem(id) {
        this.items = this.items.filter((item) => item.id !== id);
    }
    getItems() {
        return this.items;
    }
    clearItems() {
        this.items = [];
    }
}
const stateInstance = State.getInstance();
export default stateInstance;
